import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { ICategoriesApiService } from './categories-api.interface';
import { Category } from '../../model/category';
import { environment } from '@orderna/admin-panel/src/environments/environment';
import { SuccessResponse } from '../shared/success-response';
import { FindCategoryNamesResponseDto } from './dtos/find-category-names.response.dto';
import { FindCategoryNamesQueryDto } from './dtos/find-category-names.query.dto';
import { CreateCategoryRequestDto } from './dtos/create-category.request.dto';
import { CreateCategoryResponseDto } from './dtos/create-category.response.dto';
import { UpdateCategoryRequestDto } from './dtos/update-category.request.dto';
import { UpdateCategoryResponseDto } from './dtos/update-category.response.dto';
import { FindCategoryResponseDto } from './dtos/find-category.response.dto';

const API_URL = `${environment.api}/categories`;

@Injectable({
  providedIn: 'root',
})
export class CategoriesApiService implements ICategoriesApiService {
  private http = inject(HttpClient);

  async findCategoryNames(query: FindCategoryNamesQueryDto) {
    const params = new HttpParams({ fromObject: query as any });
    const response = await firstValueFrom(
      this.http.get<SuccessResponse<FindCategoryNamesResponseDto>>(
        `${API_URL}/names`,
        { params },
      ),
    );

    return response.data;
  }

  async findCategory(categoryId: number): Promise<FindCategoryResponseDto> {
    const response = await firstValueFrom(
      this.http.get<SuccessResponse<FindCategoryResponseDto>>(
        `${API_URL}/${categoryId}`,
      ),
    );

    return response.data;
  }

  async createCategory(
    category: CreateCategoryRequestDto,
  ): Promise<CreateCategoryResponseDto> {
    const response = await firstValueFrom(
      this.http.post<SuccessResponse<CreateCategoryResponseDto>>(
        API_URL,
        category,
      ),
    );

    return response.data;
  }

  async updateCategory(
    categoryId: number,
    category: UpdateCategoryRequestDto,
  ): Promise<UpdateCategoryResponseDto> {
    const response = await firstValueFrom(
      this.http.patch<SuccessResponse<UpdateCategoryResponseDto>>(
        `${API_URL}/${categoryId}`,
        category,
      ),
    );

    return response.data;
  }

  async deleteCategory(categoryId: Category['id']): Promise<void> {
    await firstValueFrom(this.http.delete(`${API_URL}/${categoryId}`));
  }
}
